import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const cancelEvent = async ({
  eventId,
  orgId,
}: {
  eventId: string;
  orgId: string;
}) => {
  const response = await axiosClient.delete(`${orgId}/events/${eventId}`);
  return response.data;
};

export function useCancelEvent(
  queryOptions?: UseMutationOptions<
    void,
    HttpError,
    { eventId: string; orgId: string }
  >,
) {
  return useMutation({
    mutationFn: cancelEvent,
    ...queryOptions,
  });
}
